import React from 'react';
import './style.css';
import cn from 'classnames';


const IconText = ({className, style, icon, iconR, text, textSize, textChild, iconClass}) => {

    return (
        <div className={cn('flex gap-2.5 justify-center items-center', textSize || 'text-sm', className)}
             style={style}>
            {icon && <img className={iconClass} src={icon} alt="icon_text"/>}
            {text && <span>{text}</span>}
            {iconR && <img className={iconClass} src={iconR} alt="icon_textR"/>}
            {textChild && textChild}
        </div>
    )
}

export default IconText
